import * as React from 'react';

const DocumentText24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M11.5 1.75C16.3325 1.75 20.25 5.66751 20.25 10.5V20C20.2498 21.2425 19.2425 22.25 18 22.25H6C4.75759 22.2499 3.7502 21.2424 3.75 20V4C3.75 2.75744 4.75747 1.75013 6 1.75H11.5ZM6 3.25C5.5859 3.25013 5.25 3.58587 5.25 4V20C5.2502 20.414 5.58602 20.7499 6 20.75H18C18.4141 20.75 18.7498 20.414 18.75 20V12C18.75 10.7574 17.7426 9.75 16.5 9.75H14.5C12.9815 9.74987 11.7502 8.51853 11.75 7V4.5C11.75 3.80964 11.1904 3.25 10.5 3.25H6ZM10.5 17.25C10.9142 17.25 11.25 17.5858 11.25 18C11.2498 18.414 10.9141 18.75 10.5 18.75H7.5C7.08602 18.7499 6.7502 18.414 6.75 18C6.75 17.5859 7.0859 17.2501 7.5 17.25H10.5ZM16.5 14.25C16.9142 14.25 17.25 14.5858 17.25 15C17.2498 15.414 16.9141 15.75 16.5 15.75H7.5C7.08602 15.7499 6.7502 15.414 6.75 15C6.75 14.5859 7.0859 14.2501 7.5 14.25H16.5ZM13.0254 3.41211C13.1693 3.7458 13.25 4.11351 13.25 4.5V7C13.2502 7.6901 13.8099 8.24987 14.5 8.25H16.5C17.2622 8.25 17.9706 8.47846 18.5625 8.86914C17.9348 6.13999 15.7696 3.99985 13.0254 3.41211Z'
				fill='black'
			/>
		</svg>
	);
};

export default DocumentText24;
